// extracted by mini-css-extract-plugin
export var ayContactItemIcon = "styles-module--ay-contact-item-icon--82ea1";
export var ayContactItemTitle = "styles-module--ay-contact-item-title--1026d";
export var ayContactWrapper = "styles-module--ay-contact-wrapper--3a725";
export var contentWrapper = "styles-module--content-wrapper--a3d2e";
export var mainContent = "styles-module--main-content--896ac";
export var title = "styles-module--title--45082";
export var wrapper = "styles-module--wrapper--83ffc";